<template>
  <v-dialog v-model="dialog" max-width="500px" @click:outside="dialog = false">
    <v-card>
      <v-card-title>Zone Message</v-card-title>
      <v-card-text v-html="message" @click="onClick"></v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="green" @click="dialog = false"> Okay </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      message: "",
    };
  },
  methods: {
    init(message) {
      this.message = message;
      console.log(message);
      this.dialog = true;
    },
    onClick(e) {
      if (e.target.href) {
        this.dialog = false;
        this.$emit("onTechnicianClick", e.target.getAttribute("data-id"));
      }
    },
  },
};
</script>

<style>
</style>